import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment
} from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridOn } from '@mui/icons-material';

const Modelos = () => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
  const [modelos, setModelos] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [nombre, setNombre] = useState('');
  const [marcaId, setMarcaId] = useState('');

  const fetchModelos = async () => {
    const res = await axios.get('/api/modelos');
    setModelos(res.data);
  };

  const fetchMarcas = async () => {
    const res = await axios.get('/api/marcas');
    setMarcas(res.data);
  };

  useEffect(() => {
    fetchModelos();
    fetchMarcas();
  }, []);

  const handleOpen = (modelo = null) => {
    if (modelo) {
      setEditId(modelo.id);
      setNombre(modelo.nombre);
      setMarcaId(modelo.marca_id);
    } else {
      setEditId(null);
      setNombre('');
      setMarcaId('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditId(null);
    setNombre('');
    setMarcaId('');
  };

  const handleSave = async () => {
    if (!nombre || !marcaId) return;
    try {
      if (editId) {
        await axios.put(`/api/modelos/${editId}`, { nombre, marca_id: marcaId });
      } else {
        await axios.post('/api/modelos', { nombre, marca_id: marcaId });
      }
      fetchModelos();
      handleClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/modelos/${id}`);
      fetchModelos();
    } catch { alert('Error al eliminar'); }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Modelos</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar..."
            value={searchValue}
            onChange={e => { setSearchValue(e.target.value); setPage(0); }}
            size="small"
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
            sx={{ flex: 1 }}
          />
          <Button color="success" variant="contained" startIcon={<GridOn />} sx={{ minWidth: 120 }} onClick={async () => {
            const { exportGenericWorkbook } = await import('../utils/excel/genericWorkbook');
            const rows = modelos
              .filter(modelo => modelo.nombre.toLowerCase().includes(searchValue.toLowerCase()))
              .map(modelo => ({ id: modelo.id, nombre: modelo.nombre, marca: marcas.find(m => m.id === modelo.marca_id)?.nombre || '' }));
            await exportGenericWorkbook({
              titulo: 'REPORTE DE MODELOS',
              sheetName: 'Modelos',
              tableName: 'tblModelos',
              fileName: 'Modelos',
              columns: [
                { key: 'id', label: 'ID', width: 8 },
                { key: 'nombre', label: 'Nombre', width: 26 },
                { key: 'marca', label: 'Marca', width: 20 }
              ],
              rows,
              searchText: searchValue,
              usuario: ''
            });
          }}>
            Exportar Excel
          </Button>
          <Button variant="contained" color="primary" startIcon={<EditIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nuevo Modelo</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ pr: 8 }}>ID</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Marca</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modelos
              .filter(modelo => modelo.nombre.toLowerCase().includes(searchValue.toLowerCase()))
              .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
              .map((modelo) => (
                <TableRow key={modelo.id}>
                  <TableCell align="center" sx={{ pr: 8 }}>{modelo.id}</TableCell>
                  <TableCell align="center">{modelo.nombre}</TableCell>
                  <TableCell align="center">{marcas.find(m => m.id === modelo.marca_id)?.nombre || ''}</TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleOpen(modelo)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => handleDelete(modelo.id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginacionControl
        page={page}
        rowsPerPage={rowsPerPage}
        count={modelos.filter(modelo => modelo.nombre.toLowerCase().includes(searchValue.toLowerCase())).length}
        onPageChange={setPage}
      />
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            {editId ? 'Editar Modelo' : 'Nuevo Modelo'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Nombre"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            fullWidth
            margin="dense"
          />
          <Autocomplete
            options={marcas}
            getOptionLabel={option => option.nombre || ''}
            value={marcas.find(m => m.id === marcaId) || null}
            onChange={(_, newValue) => setMarcaId(newValue ? newValue.id : '')}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={params => (
              <TextField {...params} label="Marca" margin="dense" fullWidth />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
          <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
    </Box>
  );
};

export default Modelos;
